export const LOAD_SETTINGS_SUCCESS = 'LOAD_SETTINGS_SUCCESS';
export const LOAD_SETTINGS_FAILURE = 'LOAD_SETTINGS_FAILURE';
export const OPEN_USER_SETTINGS_DIALOG = 'OPEN_USER_SETTINGS_DIALOG';
export const OPEN_SIGNIN_DIALOG = 'OPEN_SIGNIN_DIALOG';
export const CLOSE_SIGNIN_DIALOG = 'CLOSE_SIGNIN_DIALOG';
export const RESET_USER_SETTINGS_DIALOG = 'RESET_USER_SETTINGS_DIALOG';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE';
